import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import {
    kBalanceRange,
    kInpaintingMagicFit40Description,
    kVariationRange,
} from "@/shared/inpainting-magic-fit-4.0.api";
import { isObject } from "@/shared/utils/typeGuards";

export const kInpaintingMagicFit40FastRoute = "/inpainting-magic-fit-4.0-fast";

// Same request as Inpainting Magic Fit 4.0: only the Modal app behind it
// differs. The fast app maps balance onto its 8-step PingPong sampler so 4.0's
// defaults, balance included, carry over unchanged.
export { kBalanceRange, kVariationRange };

export interface InpaintingMagicFit40FastRequestBody {
    drivingAudioKey: string;
    timbreAudioKey: string;
    bpm: number;
    variation?: number;
    balance?: number;
    complexity?: number;
    // Absolute seconds into the model context window. The masked [start, end]
    // range of the timbre audio is regenerated; everything outside it survives
    // into the output. Omitting the pair is the purely generative case.
    inpaintMaskStartSeconds?: number;
    inpaintMaskEndSeconds?: number;
}

export const isInpaintingMagicFit40FastRequestBody = (
    value: unknown,
): value is InpaintingMagicFit40FastRequestBody =>
    isObject(value) &&
    typeof value.drivingAudioKey === "string" &&
    typeof value.timbreAudioKey === "string" &&
    typeof value.bpm === "number";

export const kInpaintingMagicFit40FastEndpoint: ApiEndpoint<
    InpaintingMagicFit40FastRequestBody,
    DownloadUrlResponse
> = {
    route: kInpaintingMagicFit40FastRoute,
    label: "Inpainting Magic Fit 4.0 fast",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v4.0 fast",
    description: kInpaintingMagicFit40Description,
    isRequestBody: isInpaintingMagicFit40FastRequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
